<div role="tablist" class="aa-tabgroup" [ngClass]="customCls" [class.justified]="justified">
  <!-- Le clic est porté par .aa-tab : la zone d'affordance (survol + trait jaune) doit être la zone cliquable.
  L'ancre garde son $event.stopPropagation() : un clic sur le texte reste géré par routerLink (href, Ctrl+clic,
  clic molette) et ne remonte donc pas déclencher onClickTab une seconde fois. -->
  @for (tab of tabs; track tab) {
    <div #tabRefs class="aa-tab" [class.disabled]="tab.disabled" [class.active]="tab.active"
      [class.popup]="!tab.tabRoute" (click)="onClickTab(tab)">
      <div class="aa-tab-title">
        @if (tab.tabRoute) {
          <a [routerLink]="tab.tabRoute" [queryParams]="tab.queryParams"
            (click)="$event.stopPropagation()">
            {{ tab.title }}
            <ng-template [ngTemplateOutlet]="$safeNavigationMigration(tab.titleTpl?.templateRef)"></ng-template>
          </a>
        } @else {
          <span>
            {{ tab.title }}
            <ng-template [ngTemplateOutlet]="$safeNavigationMigration(tab.titleTpl?.templateRef)"></ng-template>
          </span>
        }
        @if (tab.subTabItems) {
          <em class="fal fa-chevron-double-down"></em>
        }
        @if (tab.soon) {
          <span class="new-ribbon-tab">
            {{ "LAYOUT.MENU.RIBBON.SOON" | translate }}
          </span>
        }
        @if (tab.nuovo) {
          <span class="new-ribbon-tab">
            {{ "LAYOUT.MENU.RIBBON.NUOVO" | translate }}
          </span>
        }
      </div>
      <div class="aa-tab-border"></div>
    </div>
  }
</div>
<div class="aa-tab-content">
  @for (tab of tabs; track tab) {
    @if (tab.active) {
      <div role="tabpanel" [attr.aria-labelledby]="tab.id" id="{{ tab.id }}-panel">
        <ng-template [ngTemplateOutlet]="$safeNavigationMigration(tab.contentTpl?.templateRef)"></ng-template>
      </div>
    }
  }
</div>